export enum eLynxAppIDEnum {
    eLynxApp = 0,
    eLynxApp2022 = 1
}